import { createContext, useContext } from 'react';
import { CommonAnalyticsData } from 'src/types/googleAnalyticsEvents';

export const TrackedPageContext = createContext<CommonAnalyticsData | null>(null);

export function useTrackedPageContext() {
  const trackedPageContext = useContext(TrackedPageContext);
  if (trackedPageContext) return trackedPageContext;
  throw new Error('TrackedPageContext must be used only inside TrackedPageProvider');
}
